module.exports = __webpack_public_path__ + "static/media/game_cover_capy.c5a718dd.png";